import { DPYear, useContextYears, useContextYearsPropGetters } from '@rehookify/datepicker'
import React, { useCallback, useEffect } from 'react'

import Button from '@unreserved-frontend-v2/ui/button/button'
import { FlexCol } from '@unreserved-frontend-v2/ui/flex/flex-col'

interface YearProps {
  year: string
}

export const Year: React.FC<YearProps> = ({ year }) => {
  const { years } = useContextYears()
  const { yearButton } = useContextYearsPropGetters()

  const [yearSelectionVisible, setYearSelectionVisible] = React.useState(false)

  const toggleVisibility = useCallback(() => {
    setYearSelectionVisible(!yearSelectionVisible)
  }, [yearSelectionVisible])

  useEffect(() => {
    if (yearSelectionVisible) {
      requestAnimationFrame(() => {
        // Scroll to the selected year
        const selectedYear = document.getElementById(`year-${year}`)
        selectedYear?.focus()
        selectedYear?.scrollIntoView({ block: 'start', behavior: 'instant' as ScrollBehavior })
      })
    }
  }, [year, yearSelectionVisible])

  return (
    <div className="relative">
      <div
        className="flex w-[65px] cursor-pointer justify-center rounded border border-shades-50 py-2 px-3"
        onClick={toggleVisibility}
      >
        {year}
      </div>
      {yearSelectionVisible ? (
        <>
          {/* Catch clicks outside of the dropdown */}
          <div className="fixed top-0 left-0 z-40 h-screen w-screen" onClick={toggleVisibility} />

          <div className="absolute z-50 mt-[2px]">
            <FlexCol
              className="max-h-[350px] w-[65px] overflow-y-scroll rounded border border-shades-50 bg-white scrollbar-hide"
              onClick={toggleVisibility}
            >
              {years
                .sort((a, b) => b.year - a.year)
                .map((dpYear: DPYear) =>
                  !dpYear.disabled ? (
                    <Button
                      key={dpYear.year}
                      id={`year-${dpYear.year}`}
                      variant={dpYear.year === Number(year) ? 'selected' : 'ghostLight'}
                      className={'border-none px-3 text-[16px] leading-[16px] tracking-normal'}
                      {...yearButton(dpYear)}
                    >
                      {dpYear.year}
                    </Button>
                  ) : null
                )}
            </FlexCol>
          </div>
        </>
      ) : null}
    </div>
  )
}
